export const initialDefaultProps = {
    isOpen: false,
    title: 'Title',
};

export default new Map();
